var _rect, _rect2, _rect3, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUz(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uz",
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: 512,
    height: 512,
    fill: "#d80027"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    width: 512,
    height: 181.793,
    transform: "translate(0 0.007)",
    fill: "#338af3"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3",
    "data-name": "Rectangle 3",
    width: 512,
    height: 181.793,
    transform: "translate(0 330.207)",
    fill: "#6da544"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M173.389,115.322a40.987,40.987,0,0,1,32.2-40.027,40.98,40.98,0,1,0,0,80.053A40.985,40.985,0,0,1,173.389,115.322Z",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M229.808,133.95l2.775,8.537h8.977l-7.263,5.278,2.775,8.537-7.264-5.275-7.263,5.275,2.775-8.537-7.264-5.278h8.978Z",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M258.462,133.95l2.774,8.537h8.978l-7.263,5.278,2.774,8.537-7.263-5.275L251.2,156.3l2.775-8.537-7.262-5.278h8.976Z",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M287.115,133.95l2.775,8.537h8.977l-7.263,5.278,2.775,8.537-7.264-5.275-7.262,5.275,2.773-8.537-7.262-5.278h8.977Z",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M315.768,133.95l2.775,8.537h8.978l-7.264,5.278,2.775,8.537-7.264-5.275-7.262,5.275,2.774-8.537-7.263-5.278h8.977Z",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M344.422,133.95l2.774,8.537h8.978l-7.263,5.278,2.774,8.537-7.263-5.275-7.263,5.275,2.774-8.537-7.262-5.278h8.977Z",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M258.462,104.146l2.774,8.537h8.978l-7.263,5.277,2.774,8.538-7.263-5.276L251.2,126.5l2.775-8.538-7.262-5.277h8.976Z",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M287.115,104.146l2.775,8.537h8.977L291.6,117.96l2.775,8.538-7.264-5.276-7.262,5.276,2.773-8.538-7.262-5.277h8.977Z",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M315.768,104.146l2.775,8.537h8.978l-7.264,5.277,2.775,8.538-7.264-5.276-7.262,5.276,2.774-8.538-7.263-5.277h8.977Z",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M344.422,104.146l2.774,8.537h8.978l-7.263,5.277,2.774,8.538-7.263-5.276-7.263,5.276,2.774-8.538-7.262-5.277h8.977Z",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M287.115,74.342l2.775,8.539h8.977L291.6,88.156l2.775,8.54-7.264-5.278L279.853,96.7l2.773-8.54-7.262-5.275h8.977Z",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M315.768,74.342l2.775,8.539h8.978l-7.264,5.275,2.775,8.54-7.264-5.278L308.506,96.7l2.774-8.54-7.263-5.275h8.977Z",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M344.422,74.342l2.774,8.539h8.978l-7.263,5.275,2.774,8.54-7.263-5.278L337.159,96.7l2.774-8.54-7.262-5.275h8.977Z",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4",
    "data-name": "Rectangle 4",
    width: 512,
    height: 111.304,
    transform: "translate(0 200.348)",
    fill: "#f0f0f0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUz);
export default __webpack_public_path__ + "static/media/uz.8e61be4bcf6fe77dd638bc3eb39ca2d3.svg";
export { ForwardRef as ReactComponent };